import React from 'react';
import { motion } from 'framer-motion';
import smartCandlesticks from '../../../assets/images/manual/smart-candlesticks.jpg';
import orderflowImg from '../../../assets/images/manual/orderflow.jpg';
import mpOfImg from '../../../assets/images/manual/mp_of.jpg';
import optionsTableImg from '../../../assets/images/manual/options-table.jpg';
import './FeatureGridSection.css';

const FeatureGridSection = () => {
  // Feature Grid content from landing_design.json
  const features = [
    {
      icon: 'chart-line',
      title: 'Smart Candlesticks™',
      description: 'Advanced candlestick patterns with volume context for better trade decisions. Identify key patterns and reversals with our enhanced visualization.',
      image: smartCandlesticks,
      tag: 'PREMIUM FEATURE'
    },
    {
      icon: 'chart-bar',
      title: 'Orderflow Chart',
      description: 'Real-time order flow visualization showing market depth and liquidity. Track large orders and institutional activity with precision.',
      image: orderflowImg,
      tag: 'REAL-TIME DATA'
    },
    {
      icon: 'layer-group',
      title: 'MarketProfile View',
      description: 'Volume profile and market structure analysis to identify key price levels and value areas. Perfect for understanding market sentiment.',
      image: mpOfImg,
      tag: 'ADVANCED ANALYSIS'
    },
    {
      icon: 'search-dollar',
      title: 'Options Volume Scanner',
      description: 'Live options volume and unusual activity detection. Stay ahead of the market by tracking institutional options flow and unusual patterns.',
      image: optionsTableImg,
      tag: 'SMART ALERTS'
    }
  ];

  return (
    <section className="feature-grid-section" id="feature-grid-section">
      {/* Animated background elements */}
      <div className="glow-orb top-left"></div>
      <div className="glow-orb bottom-right"></div>
      
      <div className="container">
        <motion.div 
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="subtitle">POWERFUL TRADING TOOLS</span>
          <h2>Precision Tools. <span style={{ color: '#3A86FF' }}>Built for the Intraday Edge.</span></h2>
          <p>Advanced tools designed specifically for active traders</p>
        </motion.div>
        
        <div className="features-grid">
          {features.map((feature, index) => (
            <motion.div 
              key={index}
              className="feature-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              {feature.image && (
                <motion.div 
                  className="feature-image"
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: 0.2 + (index * 0.1) }}
                >
                  <img src={feature.image} alt={feature.title} />
                </motion.div>
              )}
              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
                <div className="feature-tag">{feature.tag}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureGridSection;
